import React, { use, useState } from "react";
import CryptoJS from "crypto-js";
import axios from "axios";

import { Grid } from "@material-ui/core/";
import Buttons from "../../components/Button/Button";
import TextField from "../../components/TextField/TextField";
import FieldPassword from "../../components/FieldPassword/FieldPassword";
import AlrtMessage from "../../components/AlrtMessage/AlrtMessage";
import CustomizedSnackbar from "../../hooks/Snackbar";
import PhoneInputField from "../../components/PhoneInputField/PhoneInputField";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import Button from "@mui/material/Button";
import { useRouter } from "next/router";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import CallTwoToneIcon from "@mui/icons-material/CallTwoTone";

import styles from "./form.module.css";
import { useEffect } from "react";
import Otp from "../../components/Otp/Otp";
import {
  countryWithPhonelenght,
  emailValidation,
} from "../../hooks/HelperFunctions";
import { useShoppingCart } from "../../contexts/CartContext";

function SignIn(props) {
  const [alertOpen, setAlertOpen] = useState(false);
  const [errorStatus, setErrorStatus] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("error");

  // const [showSnackbar, setAlertOpen] = useState(false);
  // const [snackbarSeverity, setAlertSeverity] = useState("success"); // severity can be: success, error, warning, info, success
  // const [snackbarMessage, setAlertMessage] = useState("");

  //================== google recapcha v3 part start ====================//
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  //================== google recapcha v3 part end ====================//
  const { cartItems, setCartItems } = useShoppingCart();
  const [curentPage, setCurentPage] = useState("sign-in");
  const [formValidationError, setFormValidationError] = useState(false);
  const [btnDisabled, setBtnDisabled] = React.useState(false);
  const [resendBtn, setResendBtn] = React.useState(false);
  const [getOTPValue, setGetOTPValue] = useState(null);
  const portalUrl =
    process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
      ? process.env.NEXT_PUBLIC_PORTAL_URL_PROD
      : process.env.NEXT_PUBLIC_PORTAL_URL_DEV;

  const [values, setValues] = React.useState({
    email: "",
    password: "",
    phone_number: "",
  });

  const router = useRouter();

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setAlertOpen(false);
  };

  const handleValidation = (validationError) => {
    // set form validation error
    if (validationError) {
      setFormValidationError(true);
    } else {
      setFormValidationError(false);
    }
  };

  const handleChanges = (fieldName, value) => {
    const fieldValue = fieldName == "email" ? value.toLowerCase() : value;
    console.log(fieldName, fieldValue);

    setValues({
      ...values,
      [fieldName]: fieldValue,
    });
  };

  const processResponse = (response, resend) => {
    setResendBtn(true);
    setBtnDisabled(false);

    if (response.data.body.status == true) {
      if (resend) {
        setAlertOpen(true);
        setAlertSeverity("success");
        setAlertMessage("Email sent");
      }
      setCurentPage("forgot-pass-result");
    } else {
      setAlertOpen(true);
      setAlertSeverity("error");
      setAlertMessage(response.data.body.message);
    }
  };
  const [phoneError, setPhoneError] = useState("");
  const [emailError, setEmailError] = useState("");
  const sendForgotPasswordRequest = (resend = false) => {
    if (values?.email === "") {
      setEmailError("Enter a valid email address");
      return false;
    }

    if (formValidationError == false) {
      const baseUrl =
        process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
          ? process.env.NEXT_PUBLIC_API_URL_PROD
          : process.env.NEXT_PUBLIC_API_URL_DEV;
      const adminPortalURL =
        process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
          ? process.env.NEXT_PUBLIC_PORTAL_URL_PROD
          : process.env.NEXT_PUBLIC_PORTAL_URL_DEV;
      const postData = {
        email: values.email,
        passwordResetURL: `${adminPortalURL}/reset-password`,
      };

      setBtnDisabled(true);

      axios
        .post(`${baseUrl}/forgotPassword`, postData)
        .then((response) => {
          if (response?.data.body.status) {
            processResponse(response, resend);
            setAlertOpen(true);
            setAlertSeverity("success");
            setAlertMessage("Email sent");
          } else {
            setAlertOpen(true);
            setAlertSeverity("error");
            setAlertMessage(
              "We can't find an account for that email address. Please try again with other information."
            );
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data.message) {
            setBtnDisabled(false);
            setAlertOpen(true);
            setAlertSeverity("error");
            setAlertMessage(err.response.data.message);
          }
        });
    }
  };

  const sendForgotPasswordWithPhone = () => {
    if (values?.phone_number === "") {
      setPhoneError("Enter a valid phone number");
      return false;
    } else {
      setPhoneError("");
    }

    const baseUrl =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_API_URL_PROD
        : process.env.NEXT_PUBLIC_API_URL_DEV;

    let postData = {
      phone_number: values?.phone_number,
    };
    axios
      .post(`${baseUrl}/resetPasswordOtpSend`, postData)
      .then((response) => {
        if (!response?.data.error) {
          setCurentPage("forgot-phone-otp");
          processStudentSignIn(response);
        } else {
          setAlertOpen(true);
          setAlertSeverity("error");
          setAlertMessage(
            "We can't find an account for that phone number. Please try again with other information."
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const processStudentSignIn = (result) => {
    console.log(result);
    const response = result.data;
    if (response.error) {
      setAlertSeverity("error");
      setAlertMessage("Sign in failed, Email, password incorrect");
      setAlertOpen(true);
    } else {
      const userData = {
        id: response.body.id,
        firstName: response.body.first_name,
        lastName: response.body.last_name,
        email: response.body.email,
        phone_number: response.body.phone_number,
        image: response.body.image,
        // "orgId": response.body.org_id,
        userRole: response.body.user_role,
      };
      setErrorStatus(false);
      // set user data and user access token
      localStorage.setItem("userData", JSON.stringify(userData));
      localStorage.setItem("userToken", response.token);
      localStorage.setItem("jwtToken", response?.data?.jwt_token);
      // set user as authorized
      localStorage.setItem("userAuthenticated", true);
      const userVerified =
        response?.body?.email_verified_at?.length == 0 ? false : true;
      localStorage.setItem("userVerified", userVerified);
      // set user id related data
      // localStorage.setItem('orgId', response.body.org_id);
      // localStorage.setItem('stuId', response.body.stuId);

      // show success message
      setAlertSeverity("success");
      setAlertMessage("Sign in Success!");
      setAlertOpen(true);
      // console.log(props.organization_invitation, 345);
      if (props.organization_invitation) {
        localStorage.setItem("invite_token", props.invite_token);
        router.push("/create-new-teaching-account");
      } else {
        setTimeout(() => {
          if (props.active_modal) {
            window.location.href = `/`;
          } else {
            router.reload(window.location.pathname);
          }
        }, 2000);
      }
    }
  };
  const [errors, setErrors] = useState({
    email: "",
    password: "",
    phone_number: "",
  });

  const checkingErrors = (postData) => {
    let error = 0;
    let errorObject = { ...errors };

    if (
      props.signUpWith != "phone_number" &&
      (!emailValidation(postData.email) || postData.email === "")
    ) {
      error++;
      errorObject.email = "Enter a valid email address.";
      setAlertSeverity("error");
      setAlertMessage(
        "Incorrect email address and / or password. You can try again or reset your password"
      );
      setAlertOpen(true);
    } else {
      errorObject.email = "";
    }
    if (postData.password == "") {
      error++;
      errorObject.password = "Password is required";
      setAlertSeverity("error");
      setAlertMessage(
        `Incorrect ${
          props.signInWith == "phone_number" ? "phone number" : "email address"
        } and / or password. You can try again or reset your password`
      );
      setAlertOpen(true);
    } else {
      errorObject.password = "";
    }
    if (props.signInWith == "phone_number" && postData.phone_number == "") {
      error++;
      // show validation error message
      setAlertSeverity("error");
      //setAlertMessage("Email and password fields are required.");
      setAlertMessage(
        "Incorrect phone number and / or password. You can try again or reset your password"
      );

      setAlertOpen(true);
      errorObject.phone_number = "Enter a valid phone number.";
    } else {
      errorObject.phone_number = "";
    }
    setErrors({ ...errors, ...errorObject });
    return error > 0 ? false : true;
  };

  useEffect(() => {
    if (errorStatus) {
      checkingErrors(values);
    }
  }, [errorStatus, values]);

  const signInHandler = (postData) => {
    setErrorStatus(true);
    const isValid = checkingErrors(postData);
    if (!isValid) {
      return false;
    }
    ///===================== recapcha ==============================///
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        postData["sign_in_with"] = props.signInWith;
        postData["phone_number"] = `${postData.phone_number}`;
        postData["token"] = token;
        postData["invite_token"] = props.invite_token;
        postData["invitationFrom"] =
          props?.invitationFrom && props?.invitationFrom != ""
            ? props?.invitationFrom
            : "";
        // console.log(process.env);

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;
        // console.log(obj.length);
        // const postData = obj ? obj : values;
        // console.log(postData, 345);
        // console.log(baseUrl);
        axios
          .post(`${baseUrl}/login`, postData)
          .then((response) => processStudentSignIn(response))
          .catch((err) => {
            console.log(err);
            if (err?.response?.data?.message) {
              setAlertSeverity("error");
              setAlertMessage(err?.response?.data?.message);
              setAlertOpen(true);
            }
          });
      } catch (error) {
        console.error("Error:", error);
      }
    });
  };

  const alertCloseHandler = () => {
    setAlertOpen(false);
  };

  const redirectToPortalForgotPassword = () => {
    if (typeof window !== "undefined") {
      let orgWebURL = window.location.origin;
      const subDomain = getSubdomain(orgWebURL);
      console.log(subDomain);
      window.location.replace(`${portalUrl}/forgot-password?org=${subDomain}`);
    }
  };

  const getSubdomain = (url) => {
    let domain = url;
    if (url.includes("://")) {
      domain = url.split("://")[1];
    }
    const subdomain = domain.split(".")[0];
    return subdomain;
  };

  //== Phone Field State start== //
  const [phone, setPhone] = React.useState({
    country: "",
    number: "",
  });
  //== Phone Field State end== //

  // const phoneChangeHandler = (ext, number) => {
  //   handleChanges("phone_number", `${number}`);
  // };
  const phoneChangeHandler = (ext, number) => {
    const getCountryDataWithPhoneLength = countryWithPhonelenght();

    let findLength = getCountryDataWithPhoneLength?.find(
      (item) => item?.phone == ext.dialCode && item?.label == ext.name
    )?.phoneLength;

    if (findLength > number?.length) {
      setErrors({
        ...errors,
        phone_number: "Enter a valid phone number.",
      });
      setPhoneError(true);
    } else {
      setErrors({
        ...errors,
        phone_number: "",
      });
      setPhoneError(false);
      handleChanges("phone_number", `${number}`);
    }
  };

  const [getTheStatus, setGetTheStatus] = useState("");

  // const [otpValue, setOtpValue] = useState("");
  // useEffect(() => {
  //   console.log(props.signInWith, 328);
  // }, [props.signInWith]);

  const handleVerify = () => {
    if (getOTPValue === null || getOTPValue?.length < 6) {
      setAlertSeverity("error");
      setAlertMessage("Enter a valid otp number");
      setAlertOpen(true);
      return false;
    }

    const baseUrl =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_API_URL_PROD
        : process.env.NEXT_PUBLIC_API_URL_DEV;
    const protalUrl =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_PORTAL_URL_PROD
        : process.env.NEXT_PUBLIC_PORTAL_URL_DEV;

    let postData = {
      reset_password_otp: getOTPValue,
    };

    axios
      .post(`${baseUrl}/verifyResetPasswordOtp`, postData)
      .then((response) => {
        // processStudentSignIn(response);
        // console.log(response, 345);
        router.push(
          `${protalUrl}/reset-password?token=${response?.data?.token}`
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleResend = () => {
    sendForgotPasswordWithPhone();
  };
  const handleBackInSignInPart = () => {
    props.handleClose();
    props.handleOpenWelcomeSignin(true);
  };
  const handleBack = () => {
    setCurentPage("forgot-pass");
    setGetTheStatus("phone_number");
  };
  const handleChange = (e, i) => {
    setOtpValue(e.target.value);
  };

  return (
    <>
      {/* <CustomizedSnackbar open={showSnackbar} severity={snackbarSeverity} message={snackbarMessage} handleClose={handleSnackbarClose} /> */}
      <div className={styles.SignContainer}>
        <div className={styles.SignContainerInner}>
          {curentPage !== "forgot-pass" && (
            <div className={styles.BackButton}>
              <Button
                variant="text"
                onClick={
                  curentPage === "forgot-phone-otp"
                    ? () => handleBack()
                    : () => handleBackInSignInPart()
                }
              >
                <ArrowBackIosNewRoundedIcon /> Back
              </Button>
            </div>
          )}

          <div className={styles.SignForm}>
            {curentPage == "sign-in" && (
              <>
                <h1>Sign in</h1>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <CustomizedSnackbar
                      open={alertOpen}
                      message={alertMessage}
                      severity={alertSeverity}
                      handleClose={alertCloseHandler}
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    {props.signInWith == "email" && (
                      <TextField
                        placeholder="Email Address"
                        required={true}
                        email={true}
                        inputType="email"
                        value={values.email}
                        handleChange={(value) => handleChanges("email", value)}
                        error={errors?.email}
                        helperText={errors?.email}
                      />
                    )}

                    {props.signInWith == "phone_number" && (
                      <PhoneInputField
                        phoneInputVariant={"materialui"} // default, materialui, underlineInput, underlineWithFlag
                        country={"us"}
                        value={phone.number}
                        countryCodeEditable={false}
                        onChange={(phone, country) =>
                          phoneChangeHandler(country, phone)
                        }
                        onBlur={() => console.log("onBlur")}
                        onKeyDown={(e) =>
                          console.log("onKeyDown", e.target.value)
                        }
                        variant="outlined"
                        // onlyCountries={["us", "ca", "gb", "my"]}
                        containerStyle={{}}
                        buttonStyle={{}}
                        inputStyle={{
                          marginLeft: "0px",
                          height: "56px",
                          width: "100%",
                          fontFamily: "Roboto-Regular",
                          fontSize: "16px",
                        }}
                        containerClass={{}}
                        // errorText={phoneError ? phoneError : ""}
                        // error={phoneError ? "error" : ""}
                        errorText={errors?.phone_number}
                        error={errors?.phone_number}
                        errorStyles={{
                          marginBottom: "5px",
                          marginLeft: "-6px",
                          fontWeight: 500,
                          color: "#d32f2f",
                        }}
                        autoFormat={true}
                        disableDropdown={false}
                        disabled={false}
                        disableCountryCode={false}
                        enableSearch={false}
                        disableSearchIcon={false}
                        placeholder={""}
                        inputProps={{}}
                        specialLabel={"Primary Phone"}
                        // error={errors?.phone_number}
                        // helperText={errors?.phone_number}
                      />
                    )}
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <FieldPassword
                      required={true}
                      value={values.password}
                      handleChange={(value) => handleChanges("password", value)}
                      placeholder="Password"
                      // error={errors?.password}
                      helperText={errors?.password}
                      error={errors?.password}
                      // validationError={errors?.password}
                      // helperText="Password is required"
                    />
                  </Grid>

                  {/* <Grid item xs={12} md={12} style={{ textAlign: "center" }}>
                    <Buttons
                      label="Forgot your password?"
                      color="#004FE0"
                      width=""
                      height="48px"
                      fontSize="14px"
                      link=""
                      onClick={() => {
                        setCurentPage("forgot-pass");
                        setAlertOpen(false);
                        setGetTheStatus(props.signInWith);
                      }}
                    />
                  </Grid> */}

                  <Grid item xs={12} md={12}>
                    <div className={styles.forgotPasswordContainer}>
                      <Buttons
                        label="Forgot your password?"
                        color="#004FE0"
                        width=""
                        height="22px"
                        fontSize="14px"
                        link=""
                        onClick={() => {
                          setCurentPage("forgot-pass");
                          setAlertOpen(false);
                          setGetTheStatus(props.signInWith);
                        }}
                      />
                    </div>
                    <Buttons
                      label="Sign in"
                      buttonColor="#004FE0"
                      border="#ccc 1px solid"
                      color="#fff"
                      width="100%"
                      height="48px"
                      fontSize="14px"
                      link=""
                      onClick={() => signInHandler(values)}
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className={styles.AlreadyText}>
                      Don't have an account?{" "}
                      <a onClick={() => props.handleClose()}>
                        <span onClick={() => props.handleOpen()}>Sign Up</span>
                      </a>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className={styles.OrDevider}>
                      <span>or</span>
                    </div>
                  </Grid>

                  {props.signInWith == "phone_number" && (
                    <Grid item xs={12} md={12}>
                      <div
                        className="SocialButton"
                        onClick={() => props.setSignInWith("email")}
                      >
                        <Buttons
                          label="Sign in with email"
                          buttonColor="#fff"
                          border="#E4E8EC 1px solid"
                          color="#004FE0"
                          width="100%"
                          height="48px"
                          fontSize="14px"
                          onClick={(e) => props.setSignInWith("email")}
                          icon={<MailOutlineRoundedIcon />}
                        />
                      </div>
                    </Grid>
                  )}

                  {props.signInWith == "email" && (
                    <Grid item xs={12} md={12}>
                      <div
                        className="SocialButton"
                        onClick={() => props.setSignInWith("phone_number")}
                      >
                        <Buttons
                          label="Sign in with phone"
                          buttonColor="#fff"
                          border="#E4E8EC 1px solid"
                          color="#004FE0"
                          width="100%"
                          height="48px"
                          fontSize="14px"
                          onClick={(e) => props.setSignInWith("phone_number")}
                          icon={<CallTwoToneIcon />}
                          IconAlign="left"
                        />
                      </div>
                    </Grid>
                  )}
                </Grid>
              </>
            )}

            {curentPage == "forgot-pass" && (
              <>
                <h1>Forgot password?</h1>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <p
                      style={{
                        margin: "0",
                        textAlign: "center",
                        fontSize: "14px",
                      }}
                    >
                      {/* Enter the email address below that you use with your
                      TAKBIR account. */}
                      {getTheStatus === "email"
                        ? "Enter the email address below that you use with your TAKBIR account."
                        : "Please enter your phone number to search for your account"}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    className={styles.forgotPassAlertBox}
                  >
                    <CustomizedSnackbar
                      open={alertOpen}
                      mb="0px"
                      message={alertMessage}
                      severity={alertSeverity}
                      handleClose={alertCloseHandler}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} className="HideLabelClass">
                    {getTheStatus === "email" && (
                      <TextField
                        placeholder="Email address"
                        required={true}
                        email={true}
                        handleValidation={handleValidation}
                        value={values.email}
                        handleChange={(value) => handleChanges("email", value)}
                        error
                        helperText={emailError ? emailError : ""}
                      />
                    )}

                    {getTheStatus === "phone_number" && (
                      <PhoneInputField
                        phoneInputVariant={"materialui"} // default, materialui, underlineInput, underlineWithFlag
                        country={"us"}
                        value={phone.number}
                        countryCodeEditable={false}
                        onChange={(phone, country) =>
                          phoneChangeHandler(country, phone)
                        }
                        onBlur={() => console.log("onBlur")}
                        onKeyDown={(e) =>
                          console.log("onKeyDown", e.target.value)
                        }
                        variant="outlined"
                        // onlyCountries={["us", "ca", "gb", "my"]}
                        containerStyle={{}}
                        buttonStyle={{}}
                        inputStyle={{
                          marginLeft: "0px",
                          height: "56px",
                          width: "100%",
                          fontFamily: "Roboto-Regular",
                          fontSize: "16px",
                        }}
                        containerClass={{}}
                        errorText={phoneError ? phoneError : ""}
                        errorStyles={{
                          marginBottom: "5px",
                          marginLeft: "-6px",
                          fontWeight: 500,
                          color: "#d32f2f",
                        }}
                        autoFormat={true}
                        disableDropdown={false}
                        disabled={false}
                        disableCountryCode={false}
                        enableSearch={false}
                        disableSearchIcon={false}
                        placeholder={""}
                        inputProps={{}}
                        specialLabel={"Primary Phone"}
                        // preferredCountries={[]}
                        // excludeCountries={[]}
                        error={phoneError ? "error" : ""}
                      />
                    )}
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Buttons
                      label={
                        getTheStatus === "email"
                          ? "Send reset link"
                          : "Send verfication code"
                      }
                      buttonColor="#004FE0"
                      border="#ccc 1px solid"
                      color="#fff"
                      width="100%"
                      height="48px"
                      fontSize="14px"
                      link=""
                      onClick={() =>
                        getTheStatus === "email"
                          ? sendForgotPasswordRequest()
                          : sendForgotPasswordWithPhone()
                      }
                      disabled={
                        getTheStatus === "email"
                          ? btnDisabled || formValidationError
                          : ""
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className={styles.OrDevider}>
                      <span>or</span>
                    </div>
                  </Grid>
                  {getTheStatus === "phone_number" && (
                    <Grid item xs={12} md={12}>
                      <div
                        className="SocialButton"
                        onClick={() => setGetTheStatus("email")}
                      >
                        <Buttons
                          label="Reset with email"
                          buttonColor="#fff"
                          border="#E4E8EC 1px solid"
                          color="#004FE0"
                          width="100%"
                          height="48px"
                          fontSize="14px"
                          onClick={(e) => setGetTheStatus("email")}
                          icon={<MailOutlineRoundedIcon />}
                        />
                      </div>
                    </Grid>
                  )}
                  {getTheStatus === "email" && (
                    <Grid item xs={12} md={12}>
                      <div
                        className="SocialButton"
                        onClick={() => setGetTheStatus("phone_number")}
                      >
                        <Buttons
                          label="Reset with phone"
                          buttonColor="#fff"
                          border="#E4E8EC 1px solid"
                          color="#004FE0"
                          width="100%"
                          height="48px"
                          fontSize="14px"
                          onClick={(e) => setGetTheStatus("phone_number")}
                          icon={<CallTwoToneIcon />}
                          IconAlign="left"
                        />
                      </div>
                    </Grid>
                  )}

                  {/* <Grid item xs={12} md={12}>
                    <Buttons
                      label="Cancel"
                      color="#004FE0"
                      width="100%"
                      height="48px"
                      fontSize="14px"
                      onClick={() => setCurentPage("sign-in")}
                    />
                  </Grid> */}
                </Grid>
              </>
            )}

            {curentPage == "forgot-pass-result" && (
              <Grid container spacing={3}>
                <Grid item xs={12} md={12} style={{ marginTop: "30px" }}>
                  <CustomizedSnackbar
                    open={alertOpen}
                    message={alertMessage}
                    severity={alertSeverity}
                    handleClose={alertCloseHandler}
                  />
                </Grid>
                <Grid item xs={12} md={12} className={styles.ThanksTextBox}>
                  <h1 className={styles.FontMedium}>
                    Thanks, email has been sent <br></br>with reset password
                    instructions
                  </h1>
                </Grid>
                <Grid item xs={12} md={12}>
                  <p
                    style={{
                      textAlign: "center",
                      margin: "0px",
                      fontSize: "13px",
                    }}
                  >
                    If you haven't received an email in 5 minutes, check your
                    spam or
                  </p>

                  <div style={{ paddingTop: "4px", marginBottom: "5px" }}>
                    <Buttons
                      label="resend"
                      color="#004FE0"
                      width="100%"
                      height="48px"
                      fontSize="14px"
                      link=""
                      onClick={() => sendForgotPasswordRequest(true)}
                    />
                  </div>

                  <Buttons
                    label="Back To Sign In"
                    buttonColor="#004FE0"
                    border="#ccc 1px solid"
                    color="#fff"
                    width="100%"
                    height="48px"
                    fontSize="14px"
                    onClick={() => {
                      setCurentPage("sign-in");
                      alertCloseHandler();
                    }}
                  />
                </Grid>
              </Grid>
            )}

            {curentPage == "forgot-phone-otp" && (
              <>
                <div className={styles.SignForm}>
                  <h1>Verify phone number</h1>

                  <Otp
                    handleVerify={handleVerify}
                    handleResend={handleResend}
                    error={false}
                    setGetOTPValue={setGetOTPValue}
                    // value={data}
                    description="An SMS with a verification code has been sent to your
                    mobile number. Enter the code to continue."
                    errormessage="OTP did not matched"
                  />

                  <div className="SignFormGrid">
                    <Grid container>
                      {/* <Grid item xs={12} md={12}>
                        <AlrtMessage
                          open={true}
                          message="We can't find an account for that phone number. Please try again with other information."
                          severity={alertSeverity}
                          closeHandler={alertCloseHandler}
                        />
                      </Grid> */}
                      <Grid item xs={12}>
                        <div className="OtpFields">
                          {/* <OTPInput
                            className="OtpField"
                            value={otp}
                            onChange={(otp) => setOtp(otp)}
                            autoFocus
                            OTPLength={6}
                            otpType="number"
                            disabled={false}
                            style={false}
                          /> */}
                          {/* <span className="OtpErrorText">
                            OTP did not matched
                          </span> */}
                        </div>
                        {/* <p
                          style={{
                            marginTop: "14px",
                            textAlign: "center",
                            fontSize: "14px",
                          }}
                        >
                          An SMS with a verification code has been sent to your
                          mobile number. Enter the code to continue.
                        </p> */}
                      </Grid>
                      {/* <Grid item xs={12}>
                        <div>
                          <Buttons
                            label="Verify"
                            buttonColor="#004FE0"
                            border="#ccc 1px solid"
                            color="#fff"
                            width="100%"
                            height="48px"
                            fontSize="14px"
                            // disabled={continueButton}
                            link=""
                            // onClick={sendResetPasswordRequest}
                          />
                          <div className={styles.BottomButton}>
                            <Buttons
                              label="Resend Code"
                              buttonColor="#FFF"
                              border="#ccc 0px solid"
                              color="#004FE0"
                              width=""
                              height="48px"
                              fontSize="14px"
                              // disabled={resendOtpButton}
                              link=""
                              // onClick={resendOtpCode}
                            />
                          </div>
                        </div>
                      </Grid> */}
                    </Grid>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* <CustomizedSnackbar
        open={alertOpen}
        severity={"success"}
        message={alertMessage}
        handleClose={alertCloseHandler}
      /> */}
    </>
  );
}

export default SignIn;
